export const SIDEBAR_WIDTH = {
  DEFAULT: 200,
  COLLAPSED: 64,
};
